<template>
  <v-container>
    <!-- <v-layout justify-space-between>
      <h1>New Fixed Cost Trip</h1>
    </v-layout>-->
    <v-layout justify-center py-3 row wrap>
      <v-flex xs12 md10 xl8>
        <SimpleCard>
          <v-layout justify-start align-content-start row wrap>
            <v-flex xs12>
              <h4>Booking Settings</h4>
            </v-flex>
            <v-flex xs12>
              <v-row align-center>
                <v-flex shrink pr-2>
                  <v-checkbox
                    type="number"
                    v-model="askDriverForTripReview"
                    label="Ask Driver for Trip Review"
                  ></v-checkbox>
                </v-flex>
                <v-btn @click="updateAskDriverForTripReview" small
                  >Update</v-btn
                >
              </v-row>
            </v-flex>
            <v-flex xs12>
              <v-row align-center>
                <v-flex shrink pr-2>
                  <v-checkbox
                    type="number"
                    v-model="enableFlagDowns"
                    label="Enable Flag Down Bookings"
                  ></v-checkbox>
                </v-flex>
                <v-btn @click="updateFlagDowns" small>Update</v-btn>
              </v-row>
            </v-flex>
            <v-flex xs12>
              <v-row align-center>
                <v-flex shrink pr-2>
                  <v-checkbox
                    type="number"
                    v-model="enableDriverCreateTrip"
                    label="Allow Driver to Book in Trips"
                  ></v-checkbox>
                </v-flex>
                <v-btn @click="updateEnableDriverCreateTrip" small
                  >Update</v-btn
                >
              </v-row>
            </v-flex>
            <v-flex xs12>
              <v-row align-center>
                <v-flex shrink pr-2>
                  <v-checkbox
                    type="number"
                    v-model="driverEnterFinalPrice"
                    label="Driver can enter final price"
                  ></v-checkbox>
                </v-flex>
                <v-btn @click="updateDriverEnterFinalPrice" small>Update</v-btn>
              </v-row>
            </v-flex>
            <v-flex xs12>
              <v-row align-center>
                <v-flex shrink pr-2>
                  <v-checkbox
                    type="number"
                    v-model="showDestinationsAccepted"
                    label="Driver can view destinations once accepted (instead of once arrived)"
                  ></v-checkbox>
                </v-flex>
                <v-btn @click="updateShowDestinationsAccepted" small
                  >Update</v-btn
                >
              </v-row>
            </v-flex>
            <v-flex xs12>
              <v-row align-center>
                <v-flex shrink pr-2>
                  <v-checkbox
                    type="number"
                    v-model="requireTaxiPhotoForOnline"
                    label="Require Taxi Photos for Login"
                  ></v-checkbox>
                </v-flex>
                <v-btn @click="updateRequireTaxiPhotoForOnline" small
                  >Update</v-btn
                >
              </v-row>
            </v-flex>
            <v-flex xs12>
              <v-row align-center>
                <v-flex shrink pr-2>
                  <v-checkbox
                      type="number"
                      v-model="destinationVisibleOnOffer"
                      label="Destination Visible On offer"
                  ></v-checkbox>
                </v-flex>
                <v-btn @click="updateDestinationVisibleOnOffer" small
                >Update</v-btn
                >
              </v-row>
            </v-flex>
            <v-flex xs12>
              <v-row align-center>
                <v-flex shrink pr-2>
                  <v-checkbox
                      type="number"
                      v-model="showTimeOnOffer"
                      label="Show Time On Offer"
                  ></v-checkbox>
                </v-flex>
                <v-btn @click="updateShowTimeOnOffer" small
                >Update</v-btn
                >
              </v-row>
            </v-flex>
          </v-layout>
        </SimpleCard>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Overview from "@/components/settings/Overview.vue";

import SimpleCard from "@/components/widget/SimpleCard.vue";

import axios from "axios";
axios.defaults.withCredentials = true;

import qs from "qs";

export default {
  name: "fixed_pricing",
  components: {
    Overview,
    SimpleCard,
  },
  data: function () {
    return {
      loading: false,
      jobOfferTimeout: null,
      enableFlagDowns: null,
      driverEnterFinalPrice: null,
      showDestinationsAccepted: null,
      askDriverForTripReview: null,
      enableDriverCreateTrip: null,
      requireTaxiPhotoForOnline: null,
      remindDriversOfExpiringDocuments: null,
      destinationVisibleOnOffer: null,
      showTimeOnOffer: null,
    };
  },
  mounted: async function () {
    this.getBookingSettings();
  },
  methods: {
    getBookingSettings: function (p) {
      this.loading = true;

      var url = `${this.$store.state.apiUrl}/booking/settings/get`;

      var vm = this;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error == "no_error") {
            vm.enableFlagDowns = res.data.enableFlagDowns;
            vm.driverEnterFinalPrice = res.data.driverEnterFinalPrice;
            vm.showDestinationsAccepted = res.data.showDestinationsAccepted;
            vm.askDriverForTripReview = res.data.askDriverForTripReview;
            vm.enableDriverCreateTrip = res.data.enableDriverCreateTrip;
            vm.requireTaxiPhotoForOnline = res.data.requireTaxiPhotoForOnline;
            vm.remindDriversOfExpiringDocuments =
              res.data.remindDriversOfExpiringDocuments;
            vm.destinationVisibleOnOffer = res.data.destinationVisibleOnOffer;
            vm.showTimeOnOffer = res.data.showTimeOnOffer;
          } else {
            alert("Failed to get settings");
          }
        })
        .catch(function (err) {
          alert("Internal Server Error");
          console.error(err);
        });
    },
    updateRequireTaxiPhotoForOnline: function (p) {
      console.log("Form Submitted");

      this.loading = true;

      var url = `${this.$store.state.apiUrl}/booking/settings/requireTaxiPhotoForOnline?enabled=${this.requireTaxiPhotoForOnline}`;

      var completed = this.success;

      axios({
        url: url,
        method: "POST",
        data: qs.stringify(p),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error == "no_error") {
            alert("Require Taxi Photos for Login Updated");
          } else {
            alert(
              "Require Taxi Photos for Login failed to update: " +
                res.data.error.message
            );
          }
        })
        .catch(function (err) {
          alert("Internal Server Error");
        });
    },
    updateFlagDowns: function (p) {
      console.log("Form Submitted");

      this.loading = true;

      var url = `${this.$store.state.apiUrl}/booking/settings/enableFlagDowns?enabled=${this.enableFlagDowns}`;

      var completed = this.success;

      axios({
        url: url,
        method: "POST",
        data: qs.stringify(p),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error == "no_error") {
            alert("Flag Down Bookings Updated");
          } else {
            alert(
              "Flag Down Bookings failed to update: " + res.data.error.message
            );
          }
        })
        .catch(function (err) {
          alert("Internal Server Error");
        });
    },
    updateEnableDriverCreateTrip: function (p) {
      console.log("Form Submitted");

      this.loading = true;

      var url = `${this.$store.state.apiUrl}/booking/settings/driverCreateTrip?enabled=${this.enableDriverCreateTrip}`;

      var completed = this.success;

      axios({
        url: url,
        method: "POST",
        data: qs.stringify(p),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error == "no_error") {
            alert("Enable Driver Create Trip Updated");
          } else {
            alert(
              "Enable Driver Create Trip failed to update: " +
                res.data.error.message
            );
          }
        })
        .catch(function (err) {
          alert("Internal Server Error");
        });
    },
    updateAskDriverForTripReview: function (p) {
      console.log("Form Submitted");

      this.loading = true;

      var url = `${this.$store.state.apiUrl}/booking/settings/askDriverForTripReview?enabled=${this.askDriverForTripReview}`;

      var completed = this.success;

      axios({
        url: url,
        method: "POST",
        data: qs.stringify(p),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error == "no_error") {
            alert("Ask Driver for Trip Review");
          } else {
            alert(
              "Ask Driver for Trip Review failed to update: " +
                res.data.error.message
            );
          }
        })
        .catch(function (err) {
          alert("Internal Server Error");
        });
    },
    updateDriverEnterFinalPrice: function (p) {
      console.log("Form Submitted");

      this.loading = true;

      var url = `${this.$store.state.apiUrl}/booking/settings/driverEnterFinalPrice?enabled=${this.driverEnterFinalPrice}`;

      var completed = this.success;

      axios({
        url: url,
        method: "POST",
        data: qs.stringify(p),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error == "no_error") {
            alert("Driver Enter Final Price Updated");
          } else {
            alert(
              "Driver Enter Final Price failed to update: " +
                res.data.error.message
            );
          }
        })
        .catch(function (err) {
          alert("Internal Server Error");
        });
    },
    updateShowDestinationsAccepted: function (p) {
      console.log("Form Submitted");

      this.loading = true;

      var url = `${this.$store.state.apiUrl}/booking/settings/showDestinationsAccepted?enabled=${this.showDestinationsAccepted}`;

      var completed = this.success;

      axios({
        url: url,
        method: "POST",
        data: qs.stringify(p),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error == "no_error") {
            alert("Show destinations when accepted Updated");
          } else {
            alert(
              "Show destinations when accepted failed to update: " +
                res.data.error.message
            );
          }
        })
        .catch(function (err) {
          alert("Internal Server Error");
        });
    },
    updateDestinationVisibleOnOffer: function (p) {
      console.log("Form Submitted");

      this.loading = true;

      var url = `${this.$store.state.apiUrl}/booking/settings/destinationVisibleOnOffer?enabled=${this.destinationVisibleOnOffer}`;

      var completed = this.success;

      axios({
        url: url,
        method: "POST",
        data: qs.stringify(p),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
          .then(function (res) {
            if (res.data.error == "no_error") {
              alert("Destination visible on offer Updated");
            } else {
              alert(
                  "Destination visible on offer failed to update: " +
                  res.data.error.message
              );
            }
          })
          .catch(function (err) {
            alert("Internal Server Error");
          });
    },
    updateShowTimeOnOffer: function (p) {
      console.log("Form Submitted");

      this.loading = true;

      var url = `${this.$store.state.apiUrl}/booking/settings/showTimeOnOffer?enabled=${this.showTimeOnOffer}`;

      var completed = this.success;

      axios({
        url: url,
        method: "POST",
        data: qs.stringify(p),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
          .then(function (res) {
            if (res.data.error == "no_error") {
              alert("Show time on offer Updated");
            } else {
              alert(
                  "Show time on offer failed to update: " +
                  res.data.error.message
              );
            }
          })
          .catch(function (err) {
            alert("Internal Server Error");
          });
    },
  },
};
</script>
